import { z } from 'zod';
export const lowStockReportSettingsSchema = z
    .object({
    enabled: z.boolean(),
    weekday: z.number().int().min(1).max(7),
    hour: z.number().int().min(0).max(23),
    recipients: z
        .array(z
        .string()
        .trim()
        .email()
        .transform((email) => email.toLowerCase()))
        .max(50),
})
    .superRefine((value, ctx) => {
    if (value.enabled && value.recipients.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['recipients'],
            message: 'At least one recipient is required when the report is enabled',
        });
    }
});
//# sourceMappingURL=low-stock-report.js.map